export default __webpack_public_path__ + "static/media/icon-upload.a7df5873.svg";